webpackJsonp([329],{

/***/ 1273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TekeCustomerMemberUpdate_vue__ = __webpack_require__(3022);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc6b1ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TekeCustomerMemberUpdate_vue__ = __webpack_require__(5568);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TekeCustomerMemberUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc6b1ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TekeCustomerMemberUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rechargeRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return memberRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return memberUpdateRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入客户名称', 'string'))],
  number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入客户编号', 'integer'))],
  phone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的手机号', 'string', 'blur', true), { pattern: /^1[3-9][0-9]\d{8}$/ })],
  email: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入邮箱', 'email'))]
};
var rechargeRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入客户名称', 'string'))],
  amount: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的充值金额', 'number'))],
  is_allow_invoice: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择申请开票', 'integer'))],
  imageurl: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传转账证明', 'array'))]
};

var memberRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入用户名称', 'string'))],
  password: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入密码', 'string'))],
  cellphone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的手机号', 'string', 'blur', true), { pattern: /^1[3-9][0-9]\d{8}$/ })],
  mail_address: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入邮箱', 'email'))],
  role: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择是否激活', 'integer'))]
};

var memberUpdateRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入用户名称', 'string'))],
  cellphone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的手机号', 'string', 'blur', true), { pattern: /^1[3-9][0-9]\d{8}$/ })],
  mail_address: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入邮箱', 'email'))],
  role: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择是否激活', 'integer'))]
};

/***/ }),

/***/ 3022:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tekeCustomer_rules_js__ = __webpack_require__(1664);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      memberUpdateRules: __WEBPACK_IMPORTED_MODULE_1__tekeCustomer_rules_js__["b" /* memberUpdateRules */],
      selectLoading: false,
      form: {
        id: this.$route.params.id,
        customerid: null,
        name: null,
        cellphone: null,
        password: '',
        mail_address: null,
        role: null
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.getCustomerDetail();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['editCustomerMember', 'getTekeCustomerMember']), {
    getCustomerDetail: function getCustomerDetail() {
      var _this = this;

      return request.page('getTekeCustomerMember', this.form.id).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
        _this.form.password = null;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (_this2.form.password && _this2.form.password.length > 1 && _this2.form.password.length < 8) {
            _this2.$message.error('密码至少输入8位！');
            return false;
          }
          return request.common('editCustomerMember', _this2.form).then(function (_ref2) {
            var data = _ref2.data;

            _this2.$message({
              showClose: true,
              message: '修改成功',
              type: 'success'
            });
            _this2.loading = false;
          });
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    }
  })

});

/***/ }),

/***/ 5568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("成员管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",staticClass:"demo-ruleForm",attrs:{"model":_vm.form,"rules":_vm.memberUpdateRules,"label-width":"120px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-row',{staticClass:"text item"},[_c('el-form-item',{attrs:{"prop":"name","label":"用户名称:"}},[_c('el-input',{attrs:{"placeholder":"请输入用户名称"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password","label":"密码:"}},[_c('el-input',{attrs:{"type":"password","placeholder":"请输入密码"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"cellphone","label":"手机号:"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号","type":"number"},model:{value:(_vm.form.cellphone),callback:function ($$v) {_vm.$set(_vm.form, "cellphone", $$v)},expression:"form.cellphone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"mail_address","label":"邮箱:"}},[_c('el-input',{attrs:{"placeholder":"请输入客户编号","type":"email"},model:{value:(_vm.form.mail_address),callback:function ($$v) {_vm.$set(_vm.form, "mail_address", $$v)},expression:"form.mail_address"}})],1)],1),_vm._v(" "),_c('el-row',[(_vm.loading)?_c('el-button',{attrs:{"type":"primary","size":"mini","native-type":"submit"}},[_vm._v("保存\n        ")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/teke_customer/member/'+_vm.form.customerid}}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("取消\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/329.40643e4348b7114bc469.js